module.exports = __webpack_public_path__ + "static/media/Painting.65416a28.png";